import { useComingSoonModal } from "@/app/hooks/use_coming_soon"
import { Button } from "@/components/buttons/button"
import { FeedbackButton } from "@/components/buttons/button.feedback"
import { PrintButton } from "@/components/buttons/button.print"
import { SidebarMenuMobile } from "@/components/sidebar_menu/sidebar_menu.mobile"
import { AvatarButton } from "@/components/user/user.avatar_button"
import { Share } from "@phosphor-icons/react"
import { ReactNode } from "react"

interface NewHeaderProps {
  children?: ReactNode
  showShareBtn?: boolean
  className?: string
}

export function Header({
  children,
  showShareBtn,
  className = "",
}: NewHeaderProps) {
  const { ComingSoonModal, openModal } = useComingSoonModal()

  return (
    <>
      <ComingSoonModal message="This feature will allow you to share content with your friends!" />
      <div
        className={`flex w-full justify-between xl:mt-2 ${className} gap-2 pb-2`}>
        <div className="flex items-center gap-2">
          <SidebarMenuMobile />
          {children}
        </div>
        <div className="flex h-full gap-2">
          <PrintButton />
          <FeedbackButton />
          {showShareBtn ?
            <Button onClick={() => openModal()} color="tertiary">
              <Share />
            </Button>
          : null}
          <AvatarButton />
        </div>
      </div>
    </>
  )
}
